"use client";

import { Eye, HeartHandshake, ShieldCheck } from "lucide-react";

const values = [
  {
    icon: ShieldCheck,
    title: "Protection that lasts",
    description: "Weather-tested materials selected for everyday Bengaluru conditions.",
  },
  {
    icon: Eye,
    title: "Safety without clutter",
    description: "Clean, measured fitting that preserves light, airflow, and your view.",
  },
  {
    icon: HeartHandshake,
    title: "Service you can trust",
    description: "Clear guidance, honest pricing, and a team that respects your home.",
  },
];

const MissionSection = () => {
  return (
    <section className="bg-[#E0F2FE] px-5 py-20 sm:px-8 md:py-28 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-[#075985] uppercase">
            Why Servani
          </p>
          <h2 className="text-4xl leading-tight font-extrabold tracking-[-0.035em] text-[#0F172A] sm:text-5xl">
            Made for safety. Fitted for real life.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-[#475569]">
            Our mission is simple: make every home safer without taking away the
            comfort, light, or openness that makes it feel like home.
          </p>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-3 md:gap-6">
          {values.map(({ icon: Icon, title, description }) => (
            <article
              key={title}
              className="rounded-[1.5rem] border border-[#0C4A6E]/8 bg-[#FFFFFF]/75 p-6 sm:p-8"
            >
              <div className="grid size-12 place-items-center rounded-2xl bg-[#0C4A6E] text-white">
                <Icon className="size-6" />
              </div>
              <h3 className="mt-6 text-xl font-extrabold text-[#0F172A]">{title}</h3>
              <p className="mt-3 text-sm leading-6 text-[#475569]">{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
